import React from "react"
import { Box, Flex } from "@chakra-ui/react"

export const BROWSER_CHROME_HEIGHT = 40
export const BROWSER_CORNER_RADIUS = 8

type Props = {
  variant?: "sm" | "lg"
}

const TopBar = ({ variant = "sm" }: Props) => {
  if (variant === "lg") {
    return (
      <Flex
        h={`${BROWSER_CHROME_HEIGHT}px`}
        backgroundColor="gray.200"
        alignItems="center"
        paddingX={4}
        borderTopRadius={`${BROWSER_CORNER_RADIUS}px`}
        gap={2}
      >
        <Box
          w={3}
          h={3}
          backgroundColor="red.400"
          borderRadius="full"
        />
        <Box
          w={3}
          h={3}
          backgroundColor="yellow.400"
          borderRadius="full"
        />
        <Box
          w={3}
          h={3}
          backgroundColor="green.400"
          borderRadius="full"
        />
      </Flex>
    )
  }

  return (
    <Flex h={5} backgroundColor="gray.500" alignItems="center" paddingX={2} borderTopRadius="lg">
      <Box w={1.5} h={1.5} backgroundColor="white" borderRadius="md" />
      <Box w={1.5} h={1.5} backgroundColor="white" borderRadius="md" ml={1} />
      <Box w={1.5} h={1.5} backgroundColor="white" borderRadius="md" ml={1} />
    </Flex>
  )
}

export default TopBar
